export const path = {
  defaultAvatarPath: '/images/tmp/default_user.png',
}
